import { render, staticRenderFns } from "./UpdateMedia.vue?vue&type=template&id=8e05fcfa"
import script from "./UpdateMedia.vue?vue&type=script&lang=js"
export * from "./UpdateMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports